export default __webpack_public_path__ + "static/media/rw.6c7fb7c3.svg";